import StorageKeys from "../../../const/StorageKeys";
import CacheStorage from "../../../service/storage/CacheStorage";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { BranchListModel } from "../../../model/branch/BranchListModel";
import ShowToast from "../../../widget/common/ui/Toast";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import SessionStorage from "../../../service/storage/SessionStorage";


const BranchListProvider = new (class BranchListProvider {
  getBranchListAPI = async (
    isHome: boolean = false
  ): Promise<BranchListModel | null> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}search/get_branch_list`;
    let body: any = {
      account_id: UtilityHelper.isEmpty(accountId) ? "0" : accountId,
      flag: isHome ? "1" : "0",
      country_id: "0",
      state_id: "0",
      city_id: "0",
      area_id: "0",
      latitude: "",
      longitude: "",
    };

    const divisionId: string =
      SessionStorage.getValue(StorageKeys.division_id) ||
      CacheStorage.getValue(StorageKeys.division_id) ||
      "";
    if (UtilityHelper.isNotEmpty(divisionId)) {
      body = { ...body, division_id: divisionId };
    }

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const BranchListModel: BranchListModel = response;
        return BranchListModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default BranchListProvider;
